import React from 'react';

const Key = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="17.6541" cy="18.4404" r="17.5" fill="#F5F7FD" />
      <path
        d="M11.9532 18.7602C10.9783 17.7852 10.4906 16.6154 10.4904 15.2507C10.4901 13.886 10.9772 12.7164 11.9518 11.7418C12.9264 10.7672 14.0965 10.2796 15.4621 10.279C16.8278 10.2783 17.9981 10.7654 18.973 11.7404C19.7937 12.561 20.2663 13.5074 20.3911 14.5796C20.5159 15.6518 20.3328 16.6477 19.8419 17.5673L25.3547 23.0801C25.6382 23.3636 25.7799 23.7072 25.7799 24.111C25.7799 24.5147 25.6382 24.8584 25.3547 25.1419C25.0495 25.447 24.6961 25.5898 24.2944 25.5701C23.8927 25.5505 23.5589 25.4077 23.293 25.1418L22.937 24.7859L21.6116 26.1113C21.3281 26.3948 20.9845 26.5366 20.5807 26.5366C20.177 26.5366 19.8334 26.3948 19.5499 26.1114C19.2664 25.8279 19.1246 25.4842 19.1247 25.0805C19.1246 24.6767 19.2664 24.3331 19.5499 24.0496L20.8753 22.7242L17.7802 19.629C16.8606 20.1199 15.8646 20.303 14.7925 20.1782C13.7203 20.0535 12.7738 19.5808 11.9532 18.7602ZM14.4323 16.2811C14.7158 16.5646 15.0594 16.7064 15.4631 16.7064C15.8669 16.7064 16.2105 16.5646 16.494 16.2811C16.7775 15.9977 16.9192 15.654 16.9192 15.2503C16.9192 14.8465 16.7775 14.5029 16.494 14.2194C16.2105 13.9359 15.8669 13.7942 15.4631 13.7942C15.0594 13.7942 14.7158 13.9359 14.4323 14.2194C14.1488 14.5029 14.007 14.8465 14.007 15.2503C14.007 15.654 14.1488 15.9977 14.4323 16.2811Z"
        fill="#455163"
      />
    </svg>
  );
};

export default Key;
